module.exports = __webpack_public_path__ + "img/no-bank.60758a9b.png";